export default "__VITE_ASSET__05648d90__"